
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","viewBox":"0 0 30 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 0H0v20h30V0z","fill":"#006AA7"}}),_c('path',{attrs:{"d":"M13 0H9v20h4V0z","fill":"#FECC00"}}),_c('path',{attrs:{"d":"M30 8H0v3.75h30V8z","fill":"#FECC00"}})])
          )
        }
      }
    